import { autoinject, bindable } from 'aurelia-framework';
import { NotificationType, ResourcedNotificationService } from '../../../components/notifications/notification-service';
import { NodeModel } from '../../../models/node-model';
import { ServiceStructureService } from '../../services/service-structure-service';
import { FiscalYearService } from '../../customers/fiscal-year-service';
import * as moment from 'moment';
import { CustomerMunicipality, MunicipalityService } from '../../municipalities/municipality-service';

@autoinject
export class SelectMeasuredServices {
	
	@bindable serviceStructureId: string;
	@bindable customerId: string;
	@bindable fiscalYearId: string;
	@bindable structureName: string;

	refreshingNodes: boolean;
	isSubmitting: boolean;

	selectedServiceIds: string[];
	selectedServiceIdsForPartialMembers: { [customerMunicipalityId: string]: string[] } = {}; // key: customerMunicipalityId, value: selected service-id's

	services: NodeModel[];
	currentYear: number = null;
	partialMembers: CustomerMunicipality[];

	constructor(private service: ServiceStructureService, private municipalityService: MunicipalityService,
		private notification: ResourcedNotificationService, private fiscalYearApi: FiscalYearService) {
		
		this.refreshingNodes = true;
		this.isSubmitting = false;
	}

	async refreshNodes(): Promise<any> {
		this.refreshingNodes = true;

		this.services = await this.service.getServiceStructure(this.serviceStructureId);

		const customerMunicipalities = await this.municipalityService.getMunicipalitiesForFiscalYear(this.fiscalYearId);
		this.partialMembers = customerMunicipalities.filter(cm => cm.type === 'PartialMember');

		const serviceSelections = await this.service.getSelectedServicesForFiscalYear(this.customerId, this.fiscalYearId, this.serviceStructureId, this.partialMembers.map(pm => pm.customerMunicipalityId)); 
		this.selectedServiceIds = serviceSelections.forCustomer;
		this.selectedServiceIdsForPartialMembers = serviceSelections.forPartialMembers;

		this.refreshingNodes = false;
	}

	hasPartialMemberServiceSelected(customerMunicipalityId: string, serviceId: string) : boolean {

		return this.selectedServiceIdsForPartialMembers[customerMunicipalityId].indexOf(serviceId) >= 0;
	}

	changePartialMemberServiceSelection(customerMunicipalityId: string, serviceId: string, selected: boolean, event: any) {

		const selectedServices = this.selectedServiceIdsForPartialMembers[customerMunicipalityId];

		if (selected) {
			selectedServices.push(serviceId);
		}
		else {
			const index = selectedServices.indexOf(serviceId);
			if (index > -1) {
				selectedServices.splice(index, 1);
			}
		}

		event.stopPropagation();
		return true;
	}

	async saveSelection() {
		this.isSubmitting = true;

		await this.service.saveServiceSelection(this.customerId, this.fiscalYearId, this.serviceStructureId, this.selectedServiceIds, this.selectedServiceIdsForPartialMembers);

		this.isSubmitting = false;
		this.notification.push('ViewMessage_SaveSucceeded', NotificationType.Success);
	}

	attached() {
		this.getStartYear();
		this.refreshNodes();
	}

	getStartYear() {
		this.fiscalYearApi.getFiscalYear(this.fiscalYearId).then(f => {
			this.currentYear = moment(f.startDate).year();
		});
	}
}
